function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#5a7a7d;stroke-linecap:round;stroke-linejoin:round;stroke-width:50px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M64.29,484.17,52,492.11a59.24,59.24,0,0,0-17.57,81.64l119.3,184.64A59.19,59.19,0,0,0,235.33,776l12.31-8a59.19,59.19,0,0,0,17.55-81.64L145.91,501.71A59.2,59.2,0,0,0,64.29,484.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M606.89,560.6,693.32,189a67.74,67.74,0,0,0-48.39-82.31l-13.77-3.56a67.71,67.71,0,0,0-82.3,48.39L455,490.91"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M297.15,521.6,283.23,98.42A67.73,67.73,0,0,1,345.71,26.2l14.16-1a67.72,67.72,0,0,1,72.24,62.47L455,490.91"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M145.93,501.71l-80.29-274a62.37,62.37,0,0,1,44-76.19l12.62-3.4a62.38,62.38,0,0,1,76.2,43.94l98.71,329.54"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M395.17,951.82C407.53,829,571.66,774.41,571.66,774.41l13.58-57.08-77.69-53.91c-30.47-24.75-34.28-66.47-13.94-102.81,15.89-28.43,48.88-17,48.88-17S688,579.33,719.42,600c67.5,44.38,17.94,213.61-9.45,265.4s-104.66,211.16-104.66,211.16l-18.9,83.56"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "28.55 561.86 45.56 848.13 149.81 1076.6"
})));

function SvgRight3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 778.32 1185.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight3);
export default __webpack_public_path__ + "static/media/right-3.22086ed2.svg";
export { ForwardRef as ReactComponent };